import PropTypes from "prop-types";
import { useState } from "react";
import useUserAuth from "helpers/hooks/useUserAuth";
import AuthModal from "components/auth/AuthModal";
import MessageModal from "components/shared/stays/MessageModal";

export default function Message({
  tripID,
  tripName,
  guideID,
  guidePrimaryEmployeeFirstName,
  guidePrimaryEmployeeImageUrl,
  children,
  responseTime = null,
  closestTrips = [],
}) {
  const authenticated = useUserAuth();

  const [showModal, setShowModal] = useState(false);
  const handleModalShow = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  return (
    <>
      <span
        onClick={handleModalShow}
        onKeyDown={null}
        role="button"
        tabIndex="-1"
      >
        {children}
      </span>
      {authenticated ? (
        <MessageModal
          show={showModal}
          setShow={setShowModal}
          tripID={tripID}
          tripName={tripName}
          recipientName={guidePrimaryEmployeeFirstName}
          guideID={guideID}
          guidePrimaryEmployeeImageUrl={guidePrimaryEmployeeImageUrl}
          closestTrips={closestTrips}
          responseTime={responseTime}
        />
      ) : (
        <AuthModal show={showModal} handleClose={handleModalClose} />
      )}
    </>
  );
}

Message.propTypes = {
  guideID: PropTypes.string.isRequired,
  guidePrimaryEmployeeFirstName: PropTypes.string.isRequired,
  guidePrimaryEmployeeImageUrl: PropTypes.string.isRequired,
  tripID: PropTypes.string.isRequired,
  tripName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  responseTime: PropTypes.number,
  closestTrips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      country: PropTypes.string,
      lowest_price: PropTypes.node,
      product_type: PropTypes.string,
      trip_type_description: PropTypes.string,
      is_featured: PropTypes.bool,
      image_url: PropTypes.string,
      distance: PropTypes.number,
    })
  ),
};
